<template>
  <div class>
     <v-card elevation="0" outlined class="d-flex flex-column h-100" min-height="350">
      <v-card-title>
        <v-icon color="secondary" large class="mr-2">youtube_searched_for</v-icon>
        <div class="d-flex flex-column">
          <span
            class="primary--text monospace-font body-1 font-weight-medium"
          >{{$t("dashboards.recentPlayers")}}</span>
          <span
            class="subheader-font body-2"
          >{{$t('dashboards.lastScouted')}}</span>
        </div>
      </v-card-title>
      <div class="d-flex flex-column pl-5 pr-3 pb-1 flex-grow-1" v-if="(players && players.length) && !loading" style="overflow:auto;">
        <PlayerDashboardItem :player="player" v-for="(player,index) in players" :key="index" embedded></PlayerDashboardItem>
      </div>
      <div class="d-flex flex-column pl-3 pr-3 pb-1 py-4 mb-7 text-center flex-grow-1" v-if="(!players || !players.length) && !loading">
        <v-icon color="primary lighten-5" v-bind:style="{'font-size':$vuetify.breakpoint.mdAndUp ? '80px' : '60px'}">emoji_people</v-icon>
        <span class="primary--text lighten--text-2 body-1">{{$t("dashboards.placeholderLastScouted")}}</span>
      </div>
      <v-skeleton-loader v-if="loading" type="list-item@10" class="flex-grow-1"></v-skeleton-loader>
      <v-divider class="my-1"></v-divider>
      <div class="d-flex justify-end px-2 py-2">
        <v-btn color="secondary" class="elevation-0 monospace-font white--text px-5" rounded small :to="`/player-scout`">{{$t('dashboards.scout')}}</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import PlayerService from "../../../services/player/player.service";
import PlayerDashboardItem from "../../player/PlayerDashboardItem";
import ResizeObserver from 'resize-observer-polyfill';
import * as moment from "moment";

export default {
  name: "LastPlayersSearch",
  components: {
    PlayerDashboardItem
  },
  props: {
  },
  data() {
    return {
      players: null,
      loading: false,
      observer: null
    };
  },
  filters: {
  },
  mounted() {
    this.loadViewData();
    this.observer = new ResizeObserver(this.onResize)
    .observe(this.$el)
  },
  methods: {
    async loadViewData() {
      await this.loadPlayers();
    },
    async loadPlayers() {
      this.loading = true;
      let playerResponse = await PlayerService.getLastPlayersSearch(10);
      this.players = _.chain(playerResponse.data).uniqBy("playerId").map(p => {
        p.time = moment(p.addedAt,'DD/MM/YYYY HH:mm').unix();
        return p
      }).orderBy(["time"],["desc"]).slice(0,10).value();
      this.loading = false;
    },
    onImgError(event,side){
      if(side === 'home'){
        game.homeTeamImgError = true;
      }else if(side === 'away'){
        game.awayTeamImgError = true;
      }
    },
    onResize () {
      this.$emit('heightChange', this.$el.clientHeight)
    },
  },
  destroyed () {
    delete this.observer
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/LastPlayersSearch.vue